module.exports = __webpack_public_path__ + "img/success.759d7ac8.png";